module.exports = __webpack_public_path__ + "static/img_4789-511e70d9cc3453fd610e065ff81acee6.webp";